import { locationUtil } from "@/common/utils";
import { globalData, fl84RegionId } from "@/context/rootContext";

const reginSetting = {
  "en": () => {
    globalData.region = "en";
    globalData.XCreatorRegion = "https://www.creator-zone.com/main/home";
  },
  "sea": () => {
    globalData.region = "sea";
    globalData.XCreatorRegion = "https://www.creator-zone.com/sea/main/home";
  },
  "mult": () => {
    globalData.region = "mult";
    globalData.XCreatorRegion = "https://www.creator-zone.com/mult/main/home";
  },
  "farlight84": () => {
    globalData.region = "farlight84";
    globalData.regionConfigId = fl84RegionId;
    globalData.XCreatorRegion = "https://farlight84.creator-zone.com/main/home";
  }
};

// 检查上次登录环境
export const checkPreLoginRegion = () => {
  const reginStatus = locationUtil.getLocationStorage("lilacCreatorRegion") || {};
  const perLoginRegion = reginStatus.region;
  return perLoginRegion && (perLoginRegion === (globalData.region || "en"));
};

// 保存登录环境
export const saveLoginRegion = (region) => {
  locationUtil.setLocationStorage("lilacCreatorRegion", { region: region || "en" });
};

// 获取地区参数
export const getRegionData = async (region) => {
  if (reginSetting[region]) {
    saveLoginRegion(region);
    reginSetting[region]();
  }
};